// Cómo se escriben los números en todo el programa.
//
// En un solo sitio porque una cifra que se ve distinta según la pantalla hace
// dudar de si es la misma cifra.

export const plata = (n) => '$' + Math.round(n || 0).toLocaleString('es-CO');

// Los kilos y los litros llevan decimales solo cuando los tienen: «200 kg» se
// lee mejor que «200,00 kg», y «0,96 kg» necesita los suyos.
export const peso = (n, unidad = 'kg') => {
  const v = Number(n) || 0;
  // Con los miles separados, como la plata.
  //
  // Salía «6396 L» al lado de un «$6.396.000», y en el parte que se le manda al
  // patrón eso se lee mal: cuatro cifras seguidas sin punto hay que contarlas
  // con el dedo para saber si son seis mil o sesenta mil.
  const texto = Number.isInteger(v)
    ? v.toLocaleString('es-CO')
    : v.toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${texto} ${unidad}`;
};

// EL PROMEDIO POR TINA. Con coma, como todo lo demás.
//
// Se escribía crudo —`5.69`— y era el único número del programa con punto: la
// plata sale «1.300.000» y los kilos «5,69 kg». En Colombia el punto separa los
// miles, así que «5.69» se lee como cinco mil seiscientos noventa. Un número de
// dos formas distintas en la misma pantalla hace dudar de si es el mismo.
export const promedio = (n) => {
  const v = Number(n);
  if (!Number.isFinite(v) || v <= 0) return '—';
  return v.toFixed(2).replace('.', ',');
};

// Cualquier número suelto, con la coma de aquí y sin inventarle decimales.
// «60.3 tinas» y «99.9%» quedaban con punto al lado de un «5,69» con coma, en
// la misma tarjeta.
export const conComa = (n) => (n === null || n === undefined || n === '')
  ? '—' : String(n).replace('.', ',');

export const fecha = (f) => {
  if (!f) return '—';
  const d = new Date(String(f).length <= 10 ? f + 'T00:00:00' : f);
  return isNaN(d) ? '—' : d.toLocaleDateString('es-CO', { day: 'numeric', month: 'short', year: 'numeric' });
};

export const hoy = () => new Date().toISOString().split('T')[0];
